module.exports = __webpack_public_path__ + "media/images/budget-cbef11dfb9fe1a3a262757778d7761ee.jpg";